import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <blockquote>
      <p parentName="blockquote">{`Prior to starting a historical data migration, ensure you do the following:`}</p>
      <ol parentName="blockquote">
        <li parentName="ol">{`Create a project on our `}<a parentName="li" {...{
            "href": "https://us.posthog.com/signup"
          }}>{`US`}</a>{` or `}<a parentName="li" {...{
            "href": "https://eu.posthog.com/signup"
          }}>{`EU`}</a>{` Cloud.`}</li>
        <li parentName="ol">{`Sign up to a paid product analytics plan on `}<a parentName="li" {...{
            "href": "https://us.posthog.com/organization/billing"
          }}>{`the billing page`}</a>{` (historic imports are free but this unlocks the necessary features).`}</li>
        <li parentName="ol">{`Raise an `}<a parentName="li" {...{
            "href": "http://us.posthog.com/home#supportModal"
          }}>{`in-app support request`}</a>{` (Target Area: Data Management) detailing where you are sending events from, how, the total volume, and the speed. For example, "`}<em parentName="li">{`we are migrating 30M events from a self-hosted instance to EU Cloud using the migration scripts at 10k events per minute.`}</em>{`"`}</li>
        <li parentName="ol">{`Wait for the OK from our team before starting the migration process to ensure that it completes successfully and is not rate limited.`}</li>
        <li parentName="ol">{`Set the `}<inlineCode parentName="li">{`historical_migration`}</inlineCode>{` option to `}<inlineCode parentName="li">{`true`}</inlineCode>{` when capturing events in the migration.`}</li>
      </ol>
    </blockquote>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      